import { AllProps } from "~/frontend/src/components/base/shared/tree/ItemTree";


export default {
    hydrate( inboundState : AllProps & { subPanelProps : any } ) : AllProps {
        const retVal = {
            ...inboundState
        };

        delete retVal.treeData;
        delete retVal.resumedNodes;
        delete retVal.flatNodeMap;
        delete retVal.flatDataObjectNodeMap;

        delete retVal.onInvalidData;

        return retVal;
    },

    rehydrate( outboundState : AllProps ) : AllProps {
        return outboundState;
    }
};
